import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import { downloadPost } from '../utils/downloadFile';
import { LabelLayout } from '../interfaces/fixedAsset/fixedAssetCount.interface';

export type StoreLabelKind = 'ITEM' | 'LOT' | 'SERIAL';

export interface StoreLabelPrint {
  kind: StoreLabelKind;
  ids: string[];
  copies: number;
  layout: LabelLayout;
  startPosition?: number;
}

/** Q3: Code128 + QR labels for items, stock lots and serial numbers. */
export const StoreLabelService = {
  print: (req: StoreLabelPrint): Promise<void> =>
    downloadPost(ENDPOINTS.STORE_LABELS,
      { ...req, institutionId: AuthService.getSelectedInstitution(), origin: window.location.origin },
      req.kind === 'LOT' ? 'lot-labels.pdf' : req.kind === 'SERIAL' ? 'serial-labels.pdf' : 'item-labels.pdf'),
};
